<template>
  <div class="shoplist favorPage">
    <header class="pageHeader">
      <div class="hBtnl" @click="gotoBack()">
        <button class="btnDiv btnDivd btnDivn">
          <i class="iconfont">&#xe601;</i>
        </button>
      </div>
      <h1 class="pageHeader-title">我的收藏</h1>

      <div class="hBtnr">
        <button class="btnDiv btnDivd btnDivn">
          <!---->
          <label class="btnDiv-text"></label>
        </button>
      </div>
    </header>
    <div v-if="list.length == 0" class="noData">
      <p>还没有收藏商品~</p>
    </div>
    <div v-else>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div>
          <div class="contentdiv">
            <ul class="itemdiv">
              <template v-for="item in list">
                <li class="item" :key="item.id">
                  <a
                    href="javascript:void(0)"
                    @click="goGoodsInfo(item.goodsId)"
                    style="color:#323232;"
                  >
                    <dl>
                      <dt>
                        <img :src="item.proGoods.firstPhoto" />
                      </dt>
                      <dd>
                        <p>{{ item.proGoods.proName }}</p>
                        <p class="price">¥{{ item.proGoods.price }}</p>
                      </dd>
                    </dl>
                  </a>
                </li>
              </template>
            </ul>
            <div class="clear-both" style="height: 0rem;"></div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shopList',
  data() {
    return {
      count: 0,
      list: [],
      isLoading: false,
    }
  },
  created() {
    this.queryGoods()
  },
  methods: {
    queryGoods() {
      var that = this
      this.$queryPage(
        'MyCollect',
        { myId: this.$store.getters.userId },
        [
          'id',
          'goodsId',
          'proGoods.firstPhoto',
          'proGoods.proName',
          'proGoods.specification',
          'proGoods.price',
        ],
        function(res) {
          that.$fill(that.list, res['data'])
        }
      )
    },
    goGoodsInfo(goodsId) {
      return this.$router.push({ path: '/shop/detail/' + goodsId })
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false
        this.count++
      }, 1000)
    },
    gotoBack() {
      this.$router.push({ path: '/my' })
    },
  },
}
</script>

<style>
.favorPage .searchdiv {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}

.favorPage .searchdiv {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.favorPage .searchdiv .sitem {
  width: 100%;
  height: 4.6rem;
  box-sizing: border-box;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.favorPage .sitem .active {
  width: 33.3%;
  box-sizing: border-box;
  float: left;
  line-height: 2.3rem;
  font-size: 1.4rem;
}
.favorPage .sitem .active p {
  width: 100%;
  color: #15a892 !important;
}
.favorPage .sitem .no {
  width: 33.3%;
  box-sizing: border-box;
  float: left;
  line-height: 2.3rem;
  font-size: 1.4rem;
}
.favorPage .sitem .no p {
  width: 100%;
  color: #000;
}

.favorPage .contentdiv {
  padding: 0 1.2rem;
  background-color: #f3f3f3;
}
.favorPage .itemdiv {
  margin-top: 0.85rem;
}

.favorPage .contentdiv .itemdiv .item:nth-of-type(odd) {
  margin-right: 1rem;
}

.favorPage .contentdiv .itemdiv .item {
  float: left;
  width: calc(50% - 0.6rem);
  margin-bottom: 1rem;
  box-sizing: border-box;
  background-color: #fff;
}
.favorPage .contentdiv .itemdiv .item dl {
  width: 100%;
}
.favorPage .contentdiv .itemdiv .item dl dt img {
  width: 100%;
  max-height: 11.3rem;
  display: block;
}
.favorPage .contentdiv .itemdiv .item dl dd {
  padding: 0.6em 1.4rem;
  font-size: 1.4rem;
  line-height: 2rem;
}

.favorPage .clear-both {
  clear: both;
  height: 5rem;
  height: 0rem;
}
.favorPage .price {
  padding-top: 0.3rem;
  color: #15a892;
}
.favorPage .price i {
  float: right;
  position: relative;
  top: 0.2rem;
  display: block;
  color: #777;
}

.favorPage .pageHeader {
  background-color: #fff;
  color: #333;
  -ms-flex-align: center;
  align-items: center;

  box-sizing: border-box;

  display: -ms-flexbox;
  display: flex;
  font-size: 14px;
  height: 40px;
  line-height: 1;
  padding: 0 10px;
  position: relative;
  text-align: center;
  white-space: nowrap;
}

.favorPage .hBtnl {
  -ms-flex: 0.5;
  flex: 0.5;
  text-align: left;
}
.favorPage .hBtnr {
  -ms-flex: 0.5;
  flex: 0.5;
  text-align: right;
}
.favorPage .pageHeader .pageHeader-title {
  font-size: 18px;
}
.favorPage .pageHeader-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: inherit;
  font-weight: 400;
  -ms-flex: 1;
  flex: 1;
}

.favorPage .hBtn {
  -ms-flex: 0.5;
  flex: 0.5;
}
.favorPage .pageHeader .btnDiv {
  background-color: transparent;
  border: 0;
  box-shadow: none;
  color: inherit;
  display: inline-block;
  padding: 0;
  font-size: inherit;
}
.favorPage .btnDivn,
.favorPage .btnDivs {
  display: inline-block;
  padding: 0 12px;
}
.favorPage .btnDivd {
  color: #656b79;
  background-color: #f6f8fa;
  box-shadow: 0 0 1px #b8bbbf;
}
.favorPage .noData {
  width: 20rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.favorPage .show {
  display: block !important;
}
.favorPage .noData:before {
  width: 100%;
  height: 9.5rem;
  display: block;
  content: '';
  background: url(../../../assets/noData.png) 50% no-repeat;
  background-size: contain;
}

.favorPage .noData p {
  font-size: 1.4rem;
  color: #999;
  text-align: center;
  height: 2.4rem;
  line-height: 2.4rem;
  margin-top: 1.4rem;
}
</style>
